export default "__VITE_ASSET__BQVc0w7W__"